import { render, staticRenderFns } from "./legendShowSanpuNumType.vue?vue&type=template&id=40fd2e37&scoped=true"
import script from "./legendShowSanpuNumType.vue?vue&type=script&lang=ts"
export * from "./legendShowSanpuNumType.vue?vue&type=script&lang=ts"
import style0 from "./legendShowSanpuNumType.vue?vue&type=style&index=0&id=40fd2e37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fd2e37",
  null
  
)

export default component.exports